document.addEventListener('DOMContentLoaded', function () {
  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
  let listenersAdded = false;

  toggleMenu();

  mobileMediaQuery.addEventListener('change', (event) => {
    toggleMenu();
  });

  function toggleMenu() {
    const footerWrapper = document.querySelector('.footer__blocks-wrapper');
    const footerBlocks = footerWrapper ? footerWrapper.querySelectorAll('.footer-block__heading') : [];

    // If the screen is mobile, add event listeners to the footer blocks
    if (mobileMediaQuery.matches) {
      if (!listenersAdded && footerBlocks.length > 0) {
        footerBlocks.forEach(function (footerBlock) {
          footerBlock.addEventListener('click', handleFooterBlockToggle);
        });
        listenersAdded = true;
      }
    } else {
      if (listenersAdded && footerBlocks.length > 0) {
        footerBlocks.forEach(function (footerBlock) {
          footerBlock.removeEventListener('click', handleFooterBlockToggle);
        });
        listenersAdded = false;
      }
    }
  }

  // Toggle the footer block
  function handleFooterBlockToggle(event) {
    const parentBlock = event.target.closest('.footer-block');
    const blockContent = parentBlock ? parentBlock.querySelector('.footer-block__details-content') : null;
    if (parentBlock) {
      parentBlock.classList.toggle('open');
      blockContent.style.maxHeight = parentBlock.classList.contains("open") ? blockContent.scrollHeight + 'px' : '0';
    }
  }
});